/**
 * ConditionalChatWidget — public-facing AI chat bubble shown ONLY to
 * unauthenticated visitors on non-admin pages. Logged-in users have their
 * own conversation tools in the dashboard; admins should never see the
 * customer-facing widget on /admin routes.
 */

import { useLocation } from "react-router-dom";
import AIChatWidget from "../AIChatWidget.jsx";

const ConditionalChatWidget = ({ isAuthenticated }) => {
  const location = useLocation();
  if (isAuthenticated) return null;
  if (location.pathname.startsWith("/admin")) return null;
  return <AIChatWidget context="faq" alwaysShow={true} />;
};

export default ConditionalChatWidget;
